/*
 * @Author: yejianfei
 * @Date: 2023-04-06 12:12:19
 * @LastEditors: yejianfei
 * @LastEditTime: 2023-04-17 14:35:08
 * @Description:
 * @Developer:
 */
import React, { useEffect, useState } from 'react';
import { Cascader } from 'antd';
import Api from '../../api';
import { isArray } from 'lodash';
const api = Api();
export default function APICascader(props) {
    const getValue = () => {
        return props.multiple
            ? (props.value && isArray(props.value) ? props.value.reduce((previous, current) => {
                previous.push(current.split('/'));
                return previous;
            }, []) : undefined)
            : (props.value && typeof (props.value) === 'string' ? props.value.split('/') : undefined);
    };
    const indexOf = (value, search, index) => {
        let idx = value.indexOf(search);
        if (index === 1) {
            return idx;
        }
        for (let i = 1; i < index; i += 1) {
            idx = value.indexOf(search, idx + 1);
        }
        return idx;
    };
    const [options, setOptions] = useState(props.options);
    const loadData = props.loader
        ? (selections) => {
            if (props.loader && selections.length) {
                const url = typeof (props.loader) === 'string'
                    ? props.loader : props.loader.children;
                const option = selections[selections.length - 1];
                option.loading = true;
                const path = {};
                path[props.cascadeParamName || 'path'] = option[props.fieldNames.path || 'path'];
                api.get(url, { params: Object.assign(Object.assign({}, (props.params || {})), path) })
                    .then((data) => {
                    option.loading = false;
                    option[props.fieldNames.children || 'children'] = data.map((item) => {
                        var _a;
                        return (Object.assign(Object.assign({}, item), { isLeaf: props.depth && props.depth - 1 !== selections.length
                                ? item[((_a = props.fieldNames) === null || _a === void 0 ? void 0 : _a.leaf) || 'leaf']
                                : true }));
                    });
                    setOptions([...(options || [])]);
                });
            }
        }
        : props.loadData;
    useEffect(() => {
        if (props.loader) {
            const url = typeof (props.loader) === 'string'
                ? props.loader : props.loader.root;
            api.get(url, { params: props.params })
                .then((data) => {
                setOptions(data.map((item) => {
                    var _a;
                    const option = Object.assign(Object.assign({}, item), { isLeaf: item[((_a = props.fieldNames) === null || _a === void 0 ? void 0 : _a.leaf) || 'leaf'], checkable: false });
                    option[props.fieldNames.children || 'children'] = [];
                    return option;
                }));
            });
        }
    }, []);
    useEffect(() => {
        if (options && props.value && props.loader) {
            const url = typeof (props.loader) === 'string' ? props.loader : props.loader.children;
            const value = typeof (props.value) === 'string' ? props.value : '';
            const paths = new Array(props.depth || 0).fill({})
                .filter((item, index) => index + 1 != props.depth)
                .map((item, index) => value.substring(0, indexOf(value, '/', index + 1)));
            Promise
                .all(paths.map((item) => api.get(url, {
                params: Object.assign(Object.assign({}, (props.params || {})), { path: item })
            })))
                .then(([departments, items]) => {
                const departmentOptions = departments.map(element => {
                    element[props.fieldNames.children || 'children'] = items ? items
                        .filter(item => item.parent_id === element.id)
                        .map((item, index) => {
                        var _a;
                        return (Object.assign(Object.assign({}, item), { isLeaf: props.depth && props.depth !== index
                                ? item[((_a = props.fieldNames) === null || _a === void 0 ? void 0 : _a.leaf) || 'leaf']
                                : true }));
                    }) : [];
                    return element;
                });
                setOptions(options.map((item) => {
                    var _a;
                    const option = Object.assign(Object.assign({}, item), { isLeaf: item[((_a = props.fieldNames) === null || _a === void 0 ? void 0 : _a.leaf) || 'leaf'], checkable: false });
                    option[props.fieldNames.children || 'children'] = departmentOptions.filter(department => department.parent_id === item.id);
                    return option;
                }));
            });
        }
    }, [props.value]);
    const _props = Object.assign({}, props);
    delete _props.cascadeParamName;
    return (React.createElement(Cascader, Object.assign({}, _props, { loadData: loadData, options: options, value: getValue(), displayRender: props.displayRender || (props.multiple ? (labels, selectedOptions) => {
            return labels.map((label, i) => {
                return React.createElement("span", { key: i },
                    label,
                    " ",
                    i < labels.length - 1 ? '/' : '',
                    " ");
            });
        } : undefined), onChange: (value, selections) => {
            if (value && props.onChange) {
                const items = props.multiple
                    ? value.reduce((previous, current) => {
                        previous.push(current.join('/'));
                        return previous;
                    }, [])
                    : value.join('/');
                props.onChange(items, selections);
                return;
            }
            props.onChange && props.onChange('', selections);
        } })));
}
